import { dashboardTypes } from './actionTypes';

export const getFilterList = () => {
  return {
    type: dashboardTypes.GET_FILTER_LIST,
  };
};

export const getFilterListSuccess = (payload: any) => ({
  type: dashboardTypes.GET_FILTER_LIST_SUCCESS,
  payload,
});

export const getFilterListFail = (error: any) => ({
  type: dashboardTypes.GET_FILTER_LIST_FAIL,
  payload: error,
});

export const getFilterData = (payload: any) => ({
  type: dashboardTypes.GET_FILTER_DATA,
  payload,
});

export const getFilterDataSuccess = (payload: any) => ({
  type: dashboardTypes.GET_FILTER_DATA_SUCCESS,
  payload,
});

export const getFilterDataFail = (error: any) => ({
  type: dashboardTypes.GET_FILTER_DATA_FAIL,
  payload: error,
});
